/*
 * Public API Surface of angular-image-viewer
 */

export * from './lib/angular-image-viewer.module';
export { AngularImageViewerComponent } from './lib/angular-image-viewer.component';
export { ImageViewerConfig} from './lib/models/image-viewer-config.model';
export { CustomImageEvent } from './lib/models/custom-image-event-model';
export { FullScreenDirective } from './lib/directives/full-screen.directive';

